import React from 'react';
import * as Routes from '@/modules/routes';
import I18n from 'i18n-js';
import ILesson from '@/types/api/Lessons';
import ITag from '@/types/api/Tags';
import clsx from 'clsx';
import { twMerge } from '@/utils';
import GoToButton from '@/components/shared/NewLessonOverview/Cards/ActionBar/GoToButton';
import EngineeringBanner from './EngineeringBanner';

type LessonCardProps = {
  programId: number,
  lesson: ILesson,
  unitColor: string,
};

const LessonCard = ({ programId, lesson, unitColor }: LessonCardProps) => {
  const lessonPath = Routes.shared_program_lesson_slide_shows_path(programId, lesson.id);
  const lessonNumber = lesson?.title_number ? I18n.t('lesson').concat(' ', lesson.title_number.toString()) : '';

  const performanceExpectations = lesson.performance_expectations?.filter((pe: ITag) => !pe.value_en.includes('ETS'));

  return (
    <div className="tw-w-full tw-h-[18rem] tw-border-solid tw-border-[1px]
        tw-border-med-grey tw-rounded-lg tw-shadow-md tw-relative tw-bg-white"
    >
      {lesson.engineering_icon && (
        <EngineeringBanner
          className="tw-absolute tw-right-4 tw--top-0.5 tw-z-[1000]"
          unitColor={unitColor}
        />
      )}
      <a className="hover:tw-no-underline" href={lessonPath}>
        <div className="tw-relative tw-h-[180px] tw-p-1 tw-mb-2">
          <div className="tw-absolute tw-top-4 tw-left-4 tw-flex">
            {performanceExpectations?.slice(0, 2)?.map((pe: ITag) => (
              <div
                key={pe.id}
                className="tw-flex tw-justify-center tw-items-center tw-rounded-sm tw-h-6 tw-bg-green tw-text-white
                tw-z-10 tw-px-4 tw-mr-2 tw-relative"
                style={{ backgroundColor: `#${unitColor}`, boxShadow: '0px 5px 5px 0px rgba(0,0,0,0.5)' }}
              >
                <span className="tw-z-10 tw-font-bold">{pe.value_en}</span>
              </div>
            ))}
          </div>
          <div className="tw-w-full tw-relative tw-rounded-lg tw-overflow-hidden">
            <div className="tw-absolute tw-w-full tw-h-[180px] tw-bg-black tw-opacity-[20%]" />
            <img
              alt={lesson.title}
              className="tw-w-full tw-h-[180px] tw-object-cover tw-bg-center tw-aspect-video"
              src={lesson.image_url}
            />
          </div>
        </div>
        <div className="tw-flex tw-flex-col tw-max-w-[75%] tw-ml-[1.5rem]">
          <span
            className={clsx('tw-mb-[0.5rem]', {
              'tw-h-[16px]': !lesson?.title_number,
              'tw-text-[16px] tw-text-dark-grey': lesson?.title_number,
            })}
          >
            {lessonNumber}
          </span>
          <p className={twMerge('tw-text-[1.25rem] tw-font-bold tw-text-tci-purple',
            'tw-h-full hover:tw-underline hover:tw-decoration-tci-purple')}
          >
            {lesson.title}
          </p>
        </div>
      </a>
      <GoToButton extraClassName="tw-absolute tw-bottom-4 tw-right-0 " href={lessonPath} />
    </div>
  );
};

export default LessonCard;
